import { GridCellProps } from "@progress/kendo-react-grid";

export const UccIndicateurCell = (props: GridCellProps) => {
    const uccExist = props.dataItem.ucc_exist;
    const hasUcc = props.dataItem.ucc && props.dataItem.ucc.length > 0;
    // const uccExistWithoutUcc = !props.dataItem.ucc || !Array.isArray(props.dataItem.ucc) && props.dataItem.ucc_exist;

    return (
        <td
            colSpan={1}
            // className="k-table-td"
            role="gridcell"
            aria-colindex={1}
            aria-selected="false"
            style={{ paddingBlock: "4px", paddingInline: "6px", textAlign: "center", color: "white", background: (hasUcc || uccExist) ? "red" : "transparent" }}
            data-grid-col-index="0"
        >
            {(hasUcc || uccExist) && (
                <span
                    style={{
                        fontWeight: "bolder",
                        color: "white",
                    }}
                >B</span>
            )}
        </td>
    );
};